<a href="{{url}}" class="container clickable">
    <svg width="17" height="17" viewBox="0 0 99 76" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M97 37.8093L3 37.8093" stroke-width="4" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M38.8093 73.6191L2.9998 37.8096L38.8093 2.00009" stroke-width="4" stroke-miterlimit="10" stroke-linecap="round"/>
    </svg>
    <span *ngIf="text !== ''">{{text}}</span>
    <span *ngIf="text === ''">{{ "BACK" | translate }}</span>
</a>
